// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2KF5Q","noInteraction":"EventWrapper_noInteraction__3nkVl","pointerPassthrough":"EventWrapper_pointerPassthrough__1xrnn"};